import styled from "styled-components";
import { cardHeaderStyles, cardContentStyles } from "../../../theme/mixins";

export const DescriptionWrapper = styled.div`
  margin-top: 25px;
`;

export const DescriptionHeader = styled.div`
  ${cardHeaderStyles};
`;

export const DescriptionContent = styled.div`
  ${cardContentStyles};
  flex-direction: column;
`;
